import {MapContainer, TileLayer, useMap} from "react-leaflet";
import L from "leaflet";
import {useEffect, useRef, useState} from "react";
import {createPortal} from "react-dom";

const PlayerLabel = ({text, buttonText, callback,}) => {
    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                padding: "5px",
            }}
        >
            <div style={{
                margin: 0,
                maxWidth: "150px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                textAlign: "left",
                userSelect: "none",
            }}> {text}</div>

            <button
                style={{
                    padding: "3px 3px",
                    background: "rgb(46,61,186)",
                    color: "white",
                    border: "none",
                    borderRadius: "3px",
                    cursor: "pointer",
                    marginLeft: "10px",

                }}
                onClick={callback}
            >
                {buttonText}
            </button>
        </div>
    )
}


const CurrentFollow = ({followSetting, setFollowSetting}) => {
    if (followSetting.following) {
        const cb = () => {
            console.log('following', followSetting.following);
            // setRefresh(!refresh);

            setFollowSetting({
                following: false,
                playerID: -1,
                playerName: "",
            })

        }
        return (
            <>
                <div style={{display: "flex", flexDirection: "column", alignItems: "center", marginTop: "10px"}}>
                    <strong style={{marginBottom: "0px"}}>正在跟随</strong>
                    <PlayerLabel
                        text={followSetting.playerName}
                        buttonText={"取消"}
                        callback={cb}
                    />
                </div>
            </>
        )
    }
    return null;
}


const HostTeams = ({hostTeams, followSetting, setFollowSetting}) => {
    return (hostTeams.current.map((p) => {
            const cb = () => {
                setFollowSetting({
                    following: true,
                    playerName: p.name,
                    playerID: p.id,
                })
            };
            return p.id ? <PlayerLabel
                key={`follow-${p.name}-${p.ID}`}
                text={p.name}
                buttonText={"跟随"}
                callback={cb}
            /> : null;

        }
    ))
}
// Custom React Component with Collapsible Panel
const InfoPanel = ({followSetting, setFollowSetting, hostTeams, refresh, setRefresh}) => {
    const [isCollapsed, setIsCollapsed] = useState(false);

    return (
        <div style={{
            position: "relative",
            background: "white",
            padding: isCollapsed ? "10px" : "10px",
            borderRadius: "3px",
            boxShadow: "0px 2px 5px rgba(0,0,0,0.3)",
            textAlign: "center",
            minWidth: isCollapsed ? "30px" : "150px",
            transition: "all 0.3s ease-in-out",
            overflow: "hidden"
        }}

        >
            {/* Toggle Button */}
            <button
                onClick={() => setIsCollapsed(!isCollapsed)}
                style={{
                    position: "absolute",
                    top: "5px",
                    right: "5px",
                    background: "#007bff",
                    color: "white",
                    border: "none",
                    borderRadius: "3px",
                    cursor: "pointer",
                    padding: "5px",
                    fontSize: "12px",
                }}
            >
                {isCollapsed ? "▼" : "▲"}
            </button>


            {!isCollapsed && (
                <>
                    <div style={{marginTop: "20px"}}>
                        <HostTeams followSetting={followSetting} setFollowSetting={setFollowSetting}
                                   hostTeams={hostTeams}/>
                        <CurrentFollow followSetting={followSetting} setFollowSetting={setFollowSetting}
                                       refresh={refresh}
                                       setRefresh={setRefresh}/>
                    </div>
                </>
            )}
        </div>
    );
};


const CustomControl = ({followSetting, setFollowSetting, hostTeams}) => {
    const map = useMap();
    const controlRef = useRef(null);

    useEffect(() => {
        if (!controlRef.current) {

            controlRef.current = L.control({position: "topright"});
            controlRef.current.onAdd = () => {
                const div = L.DomUtil.create("div", "leaflet-control-container");
                L.DomEvent.disableClickPropagation(div);
                return div;
            };
            controlRef.current.addTo(map);
        }

        return () => {
            if (controlRef.current) {
                map.removeControl(controlRef.current);
                controlRef.current = null;
            }
        };
    }, [map]);

    return controlRef.current
        ? createPortal(
            <InfoPanel followSetting={followSetting} setFollowSetting={setFollowSetting} hostTeams={hostTeams}/>,
            controlRef.current.getContainer()
        )
        : null;
};
export default CustomControl;
